import { TableOption, TableSource } from '@tripointe/tripointe-cms/types';

import { TOOLTIPS_TEXTS } from './tooltips';

const phaseTipsTableTooltips = TOOLTIPS_TEXTS.phaseTipsTable;

export const PHASE_TIPS_ACTIVE_OPTIONS: TableOption[] = [
  { action: 'edit', src: 'icons/green-edit' },
  { action: 'delete', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PHASE_TIPS_ARCHIVED_OPTIONS: TableOption[] = [
  { action: 'unarchive', src: 'icons/unarchive' },
  { action: 'deleteArchive', src: 'icons/delete' },
  { action: 'mobileMenu', src: 'icons/more' }
];

export const PHASE_TIPS_TABLE_CONFIG: TableSource = {
  displayedColumns: ['index', 'name', 'description', 'options'],
  displayedTitles: ['Order', 'Name', 'Description', 'Actions'],
  columnsConfig: [{ sorting: false }, { sorting: false }, { sorting: false }, { sorting: false }],
  displayedTooltips: [
    phaseTipsTableTooltips.order,
    phaseTipsTableTooltips.name,
    phaseTipsTableTooltips.description
  ],
  options: null,
  dataSource: []
};

export const PHASE_TIPS_ARCHIVED_TABLE_CONFIG: TableSource = {
  displayedColumns: ['name', 'description', 'options'],
  displayedTitles: ['Name', 'Description', 'Actions'],
  columnsConfig: [{ sorting: true }, { sorting: true }, { sorting: false }],
  displayedTooltips: [phaseTipsTableTooltips.name, phaseTipsTableTooltips.description],
  options: null,
  dataSource: []
};
